export default __webpack_public_path__ + "static/media/teamapt.18b44ce9.png";